/* eslint-disable import/prefer-default-export */
import { useState } from 'react';
import { PoliciesAPI } from '@services/api';
import { forceDownload } from '@plataforma/utils';

export const useDocumentLink = () => {
  const [link, setLink] = useState('');

  async function getLink(documentNumber) {
    try {
      const {
        data: { linkDocumento = '', linkMinuta = '' }
      } = await PoliciesAPI.GetPolicyInformation(documentNumber);

      const newLink = linkDocumento || linkMinuta || '';
      setLink(newLink);
    } catch (error) {
      setLink('');
    }
    return link;
  }

  function handleCopy() {
    navigator.clipboard.writeText(link);
    return link;
  }

  function handleDownload() {
    return forceDownload(link);
  }

  return {
    link,
    getLink,
    handleCopy,
    handleDownload
  };
};
